import axiosInstance from '@/setup/axios/axiosInstance'

export interface EmployeeDashboardsByUserResponse {
  dashboards?: Array<string | { code?: string; name?: string }>
}

export function getEmployeeDashboardsByUser(userId: string | number) {
  return axiosInstance.get<EmployeeDashboardsByUserResponse>(
    `/employees/by_user/?user_id=${userId}&field=dashboards`,
    {
      // Keep behavior similar to employees/by_user where 4xx can be handled by caller
      validateStatus: (status) => status < 500,
    }
  )
}
